import { render, staticRenderFns } from "./multifilerightclick.vue?vue&type=template&id=e6c7e8ee&"
import script from "./multifilerightclick.vue?vue&type=script&lang=js&"
export * from "./multifilerightclick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports